export function getView(image_slot) {
  let has_patient_image = !!image_slot.patient_image
  return image_slot.definition.slot_key === 'logo'
    ? 'LogoImage'
    : has_patient_image
    ? 'PatientImage'
    : 'ImagePlaceholder'
}
